import React, { Component } from 'react'
import Pusher from 'pusher-js'

import { SingleConPro } from 'components/common'

let pusher = new Pusher('57ed71a4a8f4d244e98b', {
    cluster: 'ap2',
    tls: true
});

class Feedbacks extends Component {
    state = {
        feedbacks: []
    }

    componentDidMount() {
        this.setState({
            feedbacks: this.props.feedbacks
        })


        const feedbackChannel = pusher.subscribe('feedbacks');
        const message = this.props.feedbackId ? `new-feedback-${this.props.feedbackId}-${this.props.type}` : `new-feedback-${this.props.debateId}-${this.props.type}`

        feedbackChannel.bind(message, data => {
            this.setState({
                feedbacks: [
                    ...this.state.feedbacks,
                    data
                ]
            })
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.feedbacks != this.props.feedbacks) {
            this.setState({ feedbacks: this.props.feedbacks })
        }
    }

    render() {
        return this.state.feedbacks
            .filter(item => item.type == this.props.type)
            .map((i, k) => (
                <SingleConPro
                    key={k}
                    {...i}
                    feedbackId={i.id}
                    debateId={i.debate_id}
                    pusher={pusher}
                    title={i.text}
                    isChild={this.props.feedbackId ? true : false}
                    isFinished={this.props.isFinished}
                />
            ))
    }
}

export default Feedbacks;